import { ResponseCode } from "services/KnowfullyAdminClient";

type ServerResponse = {
  responseCode?: ResponseCode;
  responseReason?: string | undefined;
};

/**
 * A refused business rule arrives as HTTP 200 carrying a ResponseCode, not as a thrown error, so a
 * bare `await` on a save reads as success and the screen would congratulate the user on a refusal.
 * Every mutation on this screen passes its response through here, which turns the refusal into a
 * throw that the existing catch and translateError already handle.
 */
const ensureOk = <T extends ServerResponse>(response: T): T => {
  if (response?.responseCode !== ResponseCode.OK) {
    throw new Error(response?.responseReason ?? "");
  }

  return response;
};

export default ensureOk;
